






































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass, TbGoodsSpecs, TbGrade, TbSettingsPad } from '@/http';
import { Toast,Dialog } from 'vant';
import { dialogPanel,NumberKeyboard,logoutPanel } from '@/components';
@Component({ 
    components: {
        dialogPanel,NumberKeyboard,logoutPanel
    },
})
export default class levelSet extends Vue {
   
    public $refs: {
        NumberKeyboard1:HTMLFormElement;
        NumberKeyboard2:HTMLFormElement;

    };
    
    list = [];

    /**新增会员等级 */
    show = false;
    title="新增等级";
    form:any = {
        name:"",
        discount:null,
        accumulatedAmount:null,
        isForbidden:false,
        isInitial:false,
    }
    isloading = false;
    isEdit = false;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;
    tipItem:any={};

    Loop=null;
    deleteId="";
    isDeleting=false;

    userInfo:any = {};

    get getInputStatus(){
        let val = false;
        if(this.isEdit&&this.form.name&&(this.form.name=='白银会员'||this.form.name=='黄金会员'||this.form.name=='铂金会员'||this.form.name=='钻石会员'||this.form.name=='黑钻会员')){
            val = true;
        }
        return val;
    }

    created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    }

    async mounted(){
        await this.init();
    }

    async init(){
        let res = await TbGrade.GetTbGradeList();
        res = res.filter(res=>res.id!="123456789")
        this.list = res;
    }
    getBg(name){
        let str = "bg";
        switch (name) {
            case '白银会员':
                str = "bg1";
                break;
            case '黄金会员':
                str = "bg2";
                break;
            case '铂金会员':
                str = "bg3";
                break;
            case '钻石会员':
                str = "bg4";
                break;
            case '黑钻会员':
                str = "bg5";
                break;
        
            default:
                break;
        }
        return str;
    }

    finishNum(val,type){
        switch (type) {
            case 1:
                this.form.accumulatedAmount = val;
                break;
            case 2:
                this.form.discount = val;
                break;
        
            default:
                break;
        }
    }

    resetForm(){
        this.form = {
            name:"",
            discount:null,
            accumulatedAmount:null,
            isForbidden:false,
            isInitial:false,
        }
    }
    closeFun(){
        this.resetForm();
        this.show = false;
        this.$refs['NumberKeyboard1'].collaspeFun();
        this.$refs['NumberKeyboard2'].collaspeFun();
    }
    showAdd(){
        this.isEdit = false;
        this.title = "新增等级";
        this.form.name = "VIP"+(this.list.length+1);
        this.show = true;
    }
    clickCount:number = 0;
    async rowClick(item){
        this.clickCount++
        setTimeout( async ()=>{
            if(this.clickCount == 1){
                this.clickCount = 0
                this.showEdit(item);
            }else if(this.clickCount>1){
                this.clickCount = 0
                await this.touchstart(item)
                setTimeout( async ()=>{
                    await this.touchend(item)
                },1000)
            }
        },300)
    }
    async showEdit(item){
        if(!this.userInfo.isPrimary) return;
        if(!this.hasAuth('502')){
            Dialog.alert({
                title: '提示',
                message: "暂无操作权限",
                confirmButtonText: '确定',
                confirmButtonColor:'#0491A7'
                }).then(() => {
                
                });
            return;
        }
        this.isEdit = true;
        this.title = "编辑等级";
        let res = await TbGrade.GetTbGradeById({id:item.id});
        this.form = res;
        this.show = true; 
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    changeStatus(val){
        this.form.isForbidden = val;
    }
    changeInit(val){
        this.form.isInitial = val;
    }
    async saveFun(){
        if(this.isloading) return;
        if(!this.form.name){
            Toast("请输入等级名称");
            return;
        }
        if(!this.form.accumulatedAmount){
            Toast("请输入累计消费金额");
            return;
        }
        if(!this.form.discount){
            Toast("请输入消费折扣");
            return;
        }
        if(Number(this.form.discount)>10){
            Toast("消费折扣范围0-10");
            return;
        }
        this.isloading = true;
        if(!this.isEdit){
            try {
                let res = await TbGrade.PostGrade(this.form);
                Toast("新增成功");
                await this.init();
                this.isloading = false;
                this.closeFun();
            } catch (error) {
                this.isloading = false;
                
            }
        }else{
            this.tipTitle = "更新提醒";
            this.tipText = `更新后，会员的等级将不会同步进行调整。确定更新吗？`;
            this.btnNums=2;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.tipType = 2;
            this.tipShow = true;
            
        }
    }
    async editFun(){
        try {
            let res = await TbGrade.PutTbGrade(this.form);
            Toast("编辑成功");
            await this.init();
            this.isloading = false;
            this.closeFun();
        } catch (error) {
            this.isloading = false;
            
        }
    }
    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            case 1:
                this.deleteFun();
                break;
            case 2:
                this.editFun();
                break;
        
            default:
                break;
        }
        this.tipShow = false;
    }
    async deleteFun(){
        if(this.isDeleting) return;
        this.isDeleting = true;
        try {
            let res = await TbGrade.DeleteGrade(this.deleteId);
            Toast("删除成功");
            this.init();
            this.isDeleting = false;
        } catch (error) {
            this.isDeleting = false;
        }
    }
    tipCancel(){
        this.tipShow = false;
        this.isloading = false;
    }

    touchstart(item){
        if(!this.userInfo.isPrimary) return;
        if(item.name=='白银会员'||item.name=='黄金会员'||item.name=='铂金会员'||item.name=='钻石会员'||item.name=='黑钻会员') return;
        // console.log('touchstart');
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            this.tipTitle = "删除提醒";
            this.tipText = `确定删除该等级吗？`;
            this.btnNums=2;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.tipType = 1;
            this.deleteId = item.id;
            this.tipShow = true;
        }.bind(this), 1000);//手指或者鼠标按下等待的时间
    }
    touchend(item){
        if(item.name=='白银会员'||item.name=='黄金会员'||item.name=='铂金会员'||item.name=='钻石会员'||item.name=='黑钻会员') return;
        // console.log('touchend');
        clearInterval(this.Loop);
    }
 

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/components/levelSet.vue